import { createSlice } from "@reduxjs/toolkit";

const lideresdeviajesState = {
  lideresdeviajesdata: {},
};

const lideresDeViajesSlice = createSlice({
  name: "lideresdeviajes",
  initialState: lideresdeviajesState,
  reducers: {
    lideresDeViajesData: (state, actions) => actions.payload,
    limpiarLideresDeViajesData: () => lideresdeviajesState,
  },
});

export const { lideresDeViajesData, limpiarLideresDeViajesData } = lideresDeViajesSlice.actions;

export default lideresDeViajesSlice.reducer;